import { NEW_LOOK_RADIUS } from "common/NewLook/tokens.ts";
import React, { PropsWithChildren } from "react";
import styled from "styled-components";
import { LucideIcon } from "lucide-react";
import { Tone, toneBackground, toneColor } from "common/NewLook/IconTile.tsx";

interface PillProps {
  tone?: Tone;
  icon?: LucideIcon;
  className?: string;
}

/** A small rounded status label, e.g. "LONG", "Active", "+2.4%". */
const Pill = ({
  tone = "neutral",
  icon: Icon,
  className,
  children,
}: PropsWithChildren<PillProps>) => (
  <Wrapper $tone={tone} className={className}>
    {Icon && <Icon size={12} strokeWidth={2} />}
    {children}
  </Wrapper>
);

export default Pill;

const Wrapper = styled.span<{ $tone: Tone }>`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 8px;
  border-radius: ${NEW_LOOK_RADIUS.chip}px;
  font-size: 11.5px;
  line-height: 16px;
  font-weight: ${(p) => p.theme.typography.fontWeights.MEDIUM};
  white-space: nowrap;
  color: ${(p) =>
    p.$tone === "neutral"
      ? p.theme.colors.primaryText
      : toneColor(p.theme, p.$tone)};
  background: ${(p) => toneBackground(p.theme, p.$tone)};
`;
